import { render } from "./Client.vue?vue&type=template&id=ea59ed90&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=ea59ed90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea59ed90"]])

export default __exports__